import { EVENTS, subscribe } from 'util.pubsub'

class MainProduct extends HTMLElement {
  constructor() {
    super()
    this.unsubscribe = null
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  get sectionId() {
    return this.getAttribute('section-id')
  }

  connectedCallback() {
    this.unsubscribe = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
    this.unsubscribe = subscribe(EVENTS.sliderScrollFinished, this.handleSliderScrollFinished.bind(this))
  }

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  async handleSliderScrollFinished(event) {
    console.log('sliderScrollFinished', event.detail)
  }

  async handleVariantChange(event) {
    
    if (event.detail.productId !== this.productId || event.detail.sectionId !== this.sectionId || !event.detail.html) {
      return
    }

    try {
      const newDom = await event.detail.html
      const newMainProduct = newDom.querySelector(`main-product[section-id="${this.sectionId}"]`)

      if (!newMainProduct) return

      this.updateBlock(newMainProduct, '.main-product__variants')
      this.updateBlock(newMainProduct, '.main-product__price')
      this.updateBlock(newMainProduct, '.main-product__gallery')
      // Potentially add logic here if specific components within the updated blocks need re-initialization
      // For example, if qty-picker had its own JS component:
      // if (this.querySelector('qty-picker')) {
      //   // Assuming qty-picker component has an init method or similar
      //   this.querySelector('qty-picker').init?.(); 
      // }

    } catch (error) {
      console.error('Error handling variant change:', error)
    }
  }

  updateBlock(newDom, selector) {
    const currentBlock = this.querySelector(selector)
    const newBlock = newDom.querySelector(selector)

    if (currentBlock && newBlock) {
      currentBlock.innerHTML = newBlock.innerHTML
    } else if (currentBlock && !newBlock) {
      // If the new DOM doesn't contain the block, maybe remove it? Or handle as needed.
      console.warn(`Block '${selector}' not found in updated variant HTML.`)
      // currentBlock.remove(); // Example: remove if it doesn't exist in new variant
    } else if (!currentBlock && newBlock) {
      // If the block exists in new DOM but not current, need to decide where to insert it.
      // This scenario is less likely if the initial render includes all potential blocks.
      console.warn(`Block '${selector}' found in updated variant HTML but not in current DOM.`)
    }
  }
}

customElements.define('main-product', MainProduct) 